module.exports = __webpack_public_path__ + "distVue/img/throbber_small.cb766005.svg";